import App from './home_page/HomePage.svelte';

const app = new App({
	target: document.getElementById("page_body"),
	props: {}
});

export default app;
